import { render } from "./reflectives.vue?vue&type=template&id=5be9b308&scoped=true"
import script from "./reflectives.vue?vue&type=script&lang=js"
export * from "./reflectives.vue?vue&type=script&lang=js"

import "./reflectives.vue?vue&type=style&index=0&id=5be9b308&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be9b308"]])

export default __exports__